import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("pas_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const formatPrice = (value) =>
  new Intl.NumberFormat("es-CO", { style: "currency", currency: "COP", maximumFractionDigits: 0 }).format(value);

export const WHATSAPP_NUMBER = "573114621866";
export const BOLD_LINK = "https://checkout.bold.co/payment/LNK_WUVSTYQ4FB";
export const INSTAGRAM = "https://www.instagram.com/pasionaria30";
